import { StarIcon } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface SavedViewFavoriteButtonProps {
  isStarred: boolean;
  onToggle: () => void;
  className?: string;
}

/**
 * Toggles favourite state for the currently selected saved view.
 */
const SavedViewFavoriteButton = ({
  isStarred,
  onToggle,
  className,
}: SavedViewFavoriteButtonProps) => {
  const label = isStarred ? "Remove from favorites" : "Add to favorites";

  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn("gap-2 shrink-0 text-gray-700", className)}
      onPress={onToggle}
      aria-label={label}
      aria-pressed={isStarred}
    >
      <StarIcon
        size={16}
        weight={isStarred ? "fill" : "regular"}
        className={isStarred ? "text-gray-600" : undefined}
        aria-hidden
      />
      {label}
    </Button>
  );
};

export default SavedViewFavoriteButton;
